import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { config } from 'src/app/config/config';



@Injectable({
  providedIn: 'root'
})
export class PNoteService {

  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };
  config = config;
  savedannxAList: any[] = [];
  formData = new FormData();

  constructor(private http: HttpClient) { }

  getAnxrInstDetails() {
    let URL = environment.URL + this.config.URL.getAnxrInstDetails;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL,this.options);
  }

  downloadSampleFile() {
    let URL = environment.URL + this.config.URL.downloadSampleFile;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL,this.options);
  }

  uploadAnnexure(file,reqId) {
    let URL = environment.URL + this.config.URL.uploadAnnexure;
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('reqId', reqId);
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, formData, this.options);
  }
 



  addannxAList(annxAList: any[]) {
    this.savedannxAList = annxAList;
  }


  getAnnexureADetailsByAnxrId(id: String) {
    return this.savedannxAList.find(data => data.anxrId == id);
  }

  getSavedData(){
    let URL = environment.URL + this.config.URL.getSavedData;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL,this.options);
  }

  getCurrentMonthAnnexureMaster(){
    let URL = environment.URL + this.config.URL.getCurrentMonthAnnexureMaster;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL,this.options);

  }

  uploadAnnexureBC(file, masterId, fileMasterId) {
    let URL = environment.URL + this.config.URL.uploadAnnexureBC;
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('masterId', masterId);
    formData.append('fileMasterId', fileMasterId);
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, formData, this.options);
  }

  getSubmittedPNotes(reqObj){
    let URL = environment.URL + this.config.URL.getSubmittedPNotes;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, reqObj, this.options);
  }

  confirmPNoteAnnexureByMaker(reqObj){
    let URL = environment.URL + this.config.URL.confirmPNoteAnnexureByMaker;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, reqObj, this.options);
  }

  confirmPNoteAnnexureByChecker(reqObj) {
    let URL = environment.URL + this.config.URL.confirmPNoteAnnexureByChecker;
   
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, reqObj, this.options);
  }
 
  deleteAnnexure(reqId) {
    let URL = environment.URL + this.config.URL.deleteAnnexure;
    // let URL = "http://localhost:8095/core-service/pnote/removePnoteAnnexure?reqId=PNT21052024161420153"
    const formData: FormData = new FormData();
    formData.append('reqId', reqId);
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL,formData, this.options);
  }

  downloadPnoteAnnexureById(reqId) {
    let URL = environment.URL + this.config.URL.downloadPnoteAnnexureById + '?reqId=' + reqId;
    // const formData: FormData = new FormData();
    // formData.append('reqId', reqId);
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL,{}, this.options);
  }

  getSubmissionDueDate(){
    let URL = environment.URL + this.config.URL.getSubmissionDueDate;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL,this.options);
  }

  getPnoteTradeDataChart(year:any,entityCode:any){
    let URL = environment.URL + this.config.URL.getPnoteTradeDataChart+'/'+year+"/"+entityCode;
    return this.http.get(URL);
  }

}
